<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <select
        :id="field.attribute"
        v-model="fieldValue"
        :multiple="field.multiple || false"
        class="form-control"
        :class="errorClasses"
        :disabled="isDisabled"
        :readonly="isReadonly"
        v-bind="field.attrs"
        @change="emitChange()"
      >
        <option :value="nullValue" selected :disabled="field.required">
          {{ field.placeholder || strings.select.choose }}
        </option>

        <template v-if="field.groupBy">
          <optgroup
            v-for="(options, group) in selectOptions"
            :key="group"
            :label="group"
          >
            <option
              v-for="option in options"
              :key="option.label"
              :value="option.value"
              :selected="option.value === fieldValue"
            >
              {{ option.label }}
            </option>
          </optgroup>
        </template>
        <template v-else>
          <option
            v-for="option in selectOptions"
            :key="option.label"
            :value="option.value"
            :selected="option.value === fieldValue"
          >
            {{ option.label }}
          </option>
        </template>
      </select>
    </template>
  </component>
</template>

<script>
import groupBy from 'lodash-es/groupBy'
import { FieldMixin } from '../mixins'

export default {
  mixins: [FieldMixin],

  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    /**
     * Get the input readonly state.
     */
    isReadonly() {
      return this.readonly || this.field.readonly
    },

    nullValue() {
      return this.field.nullValue || null
    },

    selectOptions() {
      if (this.field.groupBy) {
        return groupBy(
          this.field.options,
          typeof this.field.groupBy === 'string' ? this.field.groupBy : 'group'
        )
      }

      return this.field.options || []
    },
  },

  methods: {
    emitChange() {
      this.$emit('input', {
        attribute: this.field.attribute,
        value: this.fieldValue,
      })
    },
  },
}
</script>
